import FileBody from "components/shared/fileBody";
import Loader from "components/shared/loader";
import { paths } from "helpers/paths";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React, { useEffect, useRef, useState } from "react";
import { getFile } from "sources/documentAssignments";
import CommonReport from "./commonReport";

const Documents = (props) => {
    const [data, setData] = useState();
    const currentAudio = useRef(null);

    useEffect(() => {
        getFile(props.documentAssignmentId).then(setData);
    }, []);

    if (!data) {
        return (
            <div className="loader-snippet--disable-loader">
                <Loader />
            </div>
        );
    }

    if (data.length === 0) {
        return <p className="text-center text-muted">Документы не загружены</p>;
    }

    return data.map((item, i) => {
        const fileProps = { ...item, currentAudio, userId: props.userId, modal: props.add, index: i };

        return (
            <div className="col-4" key={item.id}>
                <FileBody {...fileProps} />
            </div>
        );
    });
};

export default class DocumentAssignmentProgressReport extends CommonReport {
    openDocuments = (documentAssignmentId) => {
        const id = parseInt(this.props.profile.id);
        this.props.modal({
            name: "default",
            title: "Загруженные документы",
            CustomBody: () => <Documents documentAssignmentId={documentAssignmentId} userId={id} />,
        });
    };

    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            show: !column.isAdditionalColumn,
            Cell: (props) => {
                switch (props.column.id) {
                    case "documentAssignmentId":
                        return (
                            <div
                                className="link"
                                data-document-assignment-id={props.value}
                                onClick={() => this.openDocuments(props.value)}
                            >
                                {props.value}
                            </div>
                        );
                    case "bidId":
                        return (
                            <a
                                data-bidid={props.value}
                                href={paths.bidShow("bid", props.value)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {props.value}
                            </a>
                        );
                    default:
                        return <div className="long-text">{formatValue(props.value, column.clrType)}</div>;
                }
            },
            Footer: () => this.footerVal(column),
            ...typeSpecificProps(column),
        };
    };
}
